import React, { useEffect, useRef, useState } from "react";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { Checkbox } from "primereact/checkbox";
import AddBalanceToWalletAccountModal from "./AddBalanceToWalletAccountModal";
import PackageSubscriptionOfferDefault from "../CartComponent/PackageSubscriptionOfferDefault";
import { useNavigate } from "react-router-dom";
import './GoldenButton.css';
import { getCustomerLoyaltyPointCheckDiscount } from "../../services/LoyaltyPoint/LoyaltyPoint";
import { getLocalChargesAndDiscount, getStoreLocalData } from "../../utils/localStorage";
import { STORE_BASE_URL } from "../../services/BaseURL";

import QRCode from "qrcode";
import { getCustomerSingleOrderInfo } from "../../services/OrdersAPI/Orders";
import { Button } from "primereact/button";

const DISPLAY_W = 320;
const DISPLAY_H = 480;

const PaymentDetails = ({
  paymentModeData,
  sendDataToPaymentCollectionPage,
  balanceAmount,
  userAccountBalanceAmount,
  userAccountSubscriptionUnit,
  storeCustomerId,
  storeId,
  deliveryDiscount,
  enableUserAccountDeliveryDiscount,
  setUserAccountBalanceAmountDeliveryError,
  subscriptionDiscount,
  storeUserId,
  enabledSubscriptionDiscountOnDelivery,
  appliedSubscriptionDiscount,
  paidAmount,
  storeCustomerData,
  enabledLoyaltyPointStore,
  enabledLoyaltyPointBrand,
  bookingOrderId,
  invoiceNo,
  enabledApplySubscriptionWithPackage,
  enabledAutoApplySubscriptionWithPackage,
  orderPackageData,
  enabledUPIAccount,
  upiAccountLink,
  upiAccountId,
  upiAccountName,
  enabledQRDeviceModal,
  orderSubscriptionInfo,
  orderNo,
  onRefreshQrPayment,
  enabledAmountRoundOff
}) => {

  const isRoundOffMode = enabledAmountRoundOff === 0;

  const inputRegex = isRoundOffMode
    ? /^\d*$/
    : new RegExp(`^\\d*\\.?\\d{0,${enabledAmountRoundOff}}$`);

  const [paymentError, setPaymentError] = useState("");
  const [paymentSecondError, setPaymentSecondError] = useState("");
  const [receiveAmountError, setReceiveAmountError] = useState("");
  const [receiveAmountSecondError, setReceiveAmountSecondError] = useState("");
  const [userAccountBalanceAmountError, setUserAccountBalanceAmountError] =
    useState("");

  const { storeLocalData } = getStoreLocalData();    

  const [isCheckedRefundAmountCash, setIsCheckedRefundAmountCash] =
    useState(true);
  const [
    isCheckedRefundAmountUserAccount,
    setIsCheckedRefundAmountUserAccount,
  ] = useState(false);

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3); // Add 3 months to current date

  const navigate = useNavigate();
  const [secondPaymentModeData, setSecondPaymentModeData] = useState([])
  // const charges = paymentModeData;
  const [
    addBalanceToWalletAccountModalVisible,
    setAddBalanceToWalletAccountModalVisible,
  ] = useState(false);

  const balanceAmountCal = balanceAmount.toString();

  const [addDiscountValue, setAddDiscountValue] = useState("");
  const [discountAmount, setDiscountAmount] = useState(0);
  const [selectedDiscount, setSelectedDiscount] = useState([]);

  const [charges, setCharges] = useState([]);
  const [addDiscount, setAddDiscount] = useState({});

  const [discounts, setDiscounts] = useState([]);
  const [showQRModal, setShowQRModal] = useState(false);
  const [userAccountLowBalanceError, setUserAccountLowBalanceError] = useState("")
  

  const fetchLocalChargesAndDiscount = async () => {
    const { chargesAndDiscount } = getLocalChargesAndDiscount();
    if (chargesAndDiscount && Object.keys(chargesAndDiscount).length > 0) {
      const [chargeArray, discountArray] = chargesAndDiscount.reduce(
        ([charges, discounts], item) => {
          if (
            item.chargeDiscountMode === "ALL" ||
            item.chargeDiscountMode === "DELIVERY"
          ) {
            if (item.chargeDiscountType === "CHARGE") charges.push(item);
            if (item.chargeDiscountType === "DISCOUNT") discounts.push(item);
          }
          return [charges, discounts];
        },
        [[], []]
      );
      setCharges(chargeArray);
      setDiscounts(discountArray);
    } else {
      setCharges([]);
      setDiscounts([]);
    }
  };

  useEffect(() => {
    fetchLocalChargesAndDiscount();
  }, []);
  useEffect(() => {
    setBalanceAmountValue(balanceAmountCal);
  }, [balanceAmountCal]);

  useEffect(() => {
    if (subscriptionDiscount > 0) {
      setPaymentMethodValue("USER_ACCOUNT");
      let subscriptionDiscountValue = "";
      if (!appliedSubscriptionDiscount) {
        subscriptionDiscountValue = balanceAmount - subscriptionDiscount;
      } else {
        subscriptionDiscountValue = balanceAmount;
      }
      // setReceiveAmountValue(subscriptionDiscountValue.toString())

      const minValue = Math.min(balanceAmount, userAccountBalanceAmount, orderSubscriptionInfo?.walletAmount);

      setReceiveAmountValue(minValue?.toString());
      let balanceAmountValueUpdate = 0;
      setBalanceAmountValue(balanceAmountValueUpdate.toString());
    }
  }, [subscriptionDiscount, orderSubscriptionInfo, userAccountBalanceAmount]);

  const [otherRemarkValue, setOtherRemarkValue] = useState("");
  const [receiveAmountValue, setReceiveAmountValue] = useState("");
  const [receiveAmountSecondValue, setReceiveAmountSecondValue] = useState("");
  const [balanceAmountValue, setBalanceAmountValue] = useState("");
  const [paymentMethodValue, setPaymentMethodValue] = useState("");
  const [paymentMethodSecondValue, setPaymentMethodSecondValue] = useState("")
  const [paymentMethodRefundValue, setPaymentMethodRefundValue] =
    useState("CASH");
  const [paymentWalletBalanceStatus, setPaymentWalletBalanceStatus] =
    useState(false);

  const [addMorePaymentMethod, setAddMorePaymentMethod] = useState(false)
  const [qrDeviceModalPayment, setQrDeviceModalPayment] = useState({});


  const handleOtherRemarkChange = (text) => {
    setOtherRemarkValue(text);
  };

  const handleReceiveAmountChange = (text) => {
    // resetMethod();

    if (!isRoundOffMode && text === ".") {
      setReceiveAmountValue(".");
      return;
    }

    if (!inputRegex.test(text)) return;
    const receivedAmount = parseFloat(text);
    const finalValue = isRoundOffMode ? String(Math.round(receivedAmount)) : text;

    // Reset the discountAmount to 0 when receiveAmountValue changes
    setDiscountAmount(0);
    setAddDiscountValue("");
    handleDiscountRemove();
    setUserAccountBalanceAmountDeliveryError("");
    setPaymentMethodSecondValue("");
    setPaymentSecondError("");

    if (
      paymentMethodValue === "USER_ACCOUNT" &&
      Number(finalValue || 0) > Number(userAccountBalanceAmount)
    ) {
      setUserAccountLowBalanceError("Your Account Balance is Low");
    } else {
      setUserAccountLowBalanceError("");
    }

    if (text !== "" && finalValue <= parseFloat(balanceAmountCal)) {
      setReceiveAmountValue(text);
      setReceiveAmountSecondValue("");
      setAddMorePaymentMethod(false)
      if (finalValue > 0) {
        setReceiveAmountError("");
        if (paymentMethodValue === "") {
          setPaymentError("Please select any Payment Method");
        } else {
          setPaymentError("");
        }
      } else if (finalValue === 0) {
        setReceiveAmountError("");
      } else {
        setReceiveAmountError("Please Enter Receive Amount");
      }
      // updateBalanceAmount(receivedAmount, discountAmount);
      updateBalanceAmount(finalValue, 0, 0);
    } else {
      setReceiveAmountValue("");
      // setBalanceAmountValue(balanceAmountCal);s
      setBalanceAmountValue(
        discountAmount !== ""
          ? (balanceAmount - discountAmount).toString()
          : balanceAmountCal
      );
      setPaymentError("");
      if (paymentMethodValue !== "") {
        setReceiveAmountError("Please Enter Receive Amount");
      }
    }
  };

  const handleReceiveAmountSecondChange = (text) => {
    // resetMethod();

    if (!isRoundOffMode && text === ".") {
      setReceiveAmountValue(".");
      return;
    }

    if (!inputRegex.test(text)) return;

    const receivedAmountSecond = parseFloat(text);
    const finalValue = isRoundOffMode ? String(Math.round(receivedAmountSecond)) : text;

    // Reset the discountAmount to 0 when receiveAmountValue changes
    setDiscountAmount(0);
    setAddDiscountValue("");
    handleDiscountRemove();
    setUserAccountBalanceAmountDeliveryError("");

    if (
      paymentMethodSecondValue === "USER_ACCOUNT" &&
      Number(finalValue || 0) > Number(userAccountBalanceAmount)
    ) {
      setUserAccountLowBalanceError("Your Account Balance is Low");
    } else {
      setUserAccountLowBalanceError("");
    }


    const primaryAmount = parseFloat(receiveAmountValue || 0);
    if (text !== "" && finalValue <= (parseFloat(balanceAmountCal) - primaryAmount)) {
      setReceiveAmountSecondValue(text);
      if (finalValue > 0) {
        setReceiveAmountSecondError("");
        if (paymentMethodSecondValue === "") {
          setPaymentSecondError("Please select any Payment Method");
        } else {
          setPaymentSecondError("");
        }
      } else if (finalValue === 0) {
        setReceiveAmountSecondError("");
      } else {
        setReceiveAmountSecondError("Please Enter Receive Amount");
      }
      // updateBalanceAmount(receivedAmount, discountAmount);
      updateBalanceAmount(primaryAmount, finalValue, 0);
    } else {
      setReceiveAmountSecondValue("");
      // setBalanceAmountValue(balanceAmountCal);s
      setBalanceAmountValue(
        discountAmount !== ""
          ? (balanceAmount - discountAmount).toString()
          : balanceAmountCal
      );
      setPaymentSecondError("");
      if (paymentMethodSecondValue !== "") {
        setReceiveAmountSecondError("Please Enter Receive Amount");
      }
    }
  };

  const handleAddMorePaymentMethod = () => {
    setAddMorePaymentMethod(!addMorePaymentMethod)
  }

  const handleBalanceAmountChange = (text) => {
    setBalanceAmountValue(text);
  };
  const addDiscountsData = discounts.map((item, index) => ({
    id: index + 1,
    chargeDiscountId: item.id,
    name: item.name,
    code: item.name,
    amount: item.chargeDiscount,
    chargeDiscountType: item.chargeDiscountType,
    chargeDiscountTypeIn: item.chargeDiscountTypeIn,
    description: item.description,
    orderChargeDiscountMode: item.chargeDiscountMode,
  }));

  const dropdownItemsDiscount = addDiscountsData.filter(
    (discount) =>
      !selectedDiscount.some(
        (selectedDiscount) => selectedDiscount.id === discount.id
      )
  );

  const getChargeDiscountSymbol = (type) => {
    switch (type) {
      case "AMOUNT":
        return storeLocalData?.currencySymbol; // You can use any symbol you prefer for Amount
      case "PERCENTAGE":
        return "%"; // Use '%' symbol for PERCENTAGE
      default:
        return "";
    }
  };

  const receivePaymentDetailsInfo = ({ status }) => {
    setPaymentWalletBalanceStatus(status);
  };

  const paymentRefundMode = ["CASH", "USER_ACCOUNT"];

  const [
    checkedPackageSubscriptionOfferId,
    setCheckedPackageSubscriptionOfferId,
  ] = useState(null);

  const [
    checkedPackageSubscriptionOfferValue,
    setCheckedPackageSubscriptionOfferValue,
  ] = useState(null);

  const handleCheckPackageSubscriptionOffer = ({
    selectedItemId,
    selectedItemValue,
  }) => {
    if (selectedItemId !== checkedPackageSubscriptionOfferId) {
      setCheckedPackageSubscriptionOfferId(selectedItemId);
      setCheckedPackageSubscriptionOfferValue(selectedItemValue);
    }
  };

  sendDataToPaymentCollectionPage({
    paymentMethodValue,
    receiveAmountValue,
    paymentMethodSecondValue,
    receiveAmountSecondValue,
    otherRemarkValue,
    paymentError,
    paymentSecondError,
    receiveAmountError,
    receiveAmountSecondError,
    userAccountBalanceAmountError,
    discountAmount,
    addDiscount,
    paymentWalletBalanceStatus,
    paymentMethodRefundValue,
    isCheckedRefundAmountCash,
    isCheckedRefundAmountUserAccount,
    checkedPackageSubscriptionOfferId,
    checkedPackageSubscriptionOfferValue,
    qrDeviceModalPayment,
    userAccountLowBalanceError
  });

  const handleAddDiscountChange = (discount) => {
    setAddDiscount(discount);
    setAddDiscountValue(discount.name);
    let additionalDiscounts = 0;

    if (discount.chargeDiscountTypeIn === "AMOUNT") {
      additionalDiscounts = discount.amount;
    } else if (discount.chargeDiscountTypeIn === "PERCENTAGE") {
      additionalDiscounts =
        (Number(Number((balanceAmountCal))?.toFixed(enabledAmountRoundOff)) * discount.amount) / 100;
    }

    if (Number(Number((balanceAmountCal))?.toFixed(enabledAmountRoundOff)) 
        - (Number(Number((receiveAmountValue))?.toFixed(enabledAmountRoundOff)) 
        + Number(Number(receiveAmountSecondValue || 0)?.toFixed(enabledAmountRoundOff))) 
        < additionalDiscounts)
      {
      additionalDiscounts = Number(Number((balanceAmountCal))?.toFixed(enabledAmountRoundOff))
        - (Number(Number((receiveAmountValue))?.toFixed(enabledAmountRoundOff))
        + Number(Number(receiveAmountSecondValue || 0)?.toFixed(enabledAmountRoundOff)));
    }
    setDiscountAmount(additionalDiscounts);
    updateBalanceAmount(receiveAmountValue, receiveAmountSecondValue, additionalDiscounts);
  };

  // const updateBalanceAmount = (receivedAmount, discount) => {
  //   const calculatedBalance =
  //     parseInt(balanceAmountCal) - receivedAmount - discount;
  //   setBalanceAmountValue(calculatedBalance.toString());
  // };

  const updateBalanceAmount = (primaryAmount, secondaryAmount, discount) => {
    // const secondaryAmount = parseInt(receiveAmountSecondValue || 0);
    const receivedTotal = Number(Number(primaryAmount || 0)?.toFixed(enabledAmountRoundOff)) + Number(Number(secondaryAmount || 0)?.toFixed(2));
    const calculatedBalance = Number(Number((balanceAmountCal) - receivedTotal - discount)?.toFixed(enabledAmountRoundOff));
    setBalanceAmountValue(calculatedBalance.toString());
  };

  const handlePaymentMethodChange = (method) => {
    setPaymentMethodValue(method);
    setPaymentError("");
    setUserAccountBalanceAmountDeliveryError("");
    setReceiveAmountValue("");
    setReceiveAmountSecondValue("");
    setAddMorePaymentMethod(false)
    setPaymentMethodSecondValue("");
    setPaymentSecondError("");
    setReceiveAmountSecondError("")
    const filteredPaymentModes = paymentModeData.filter(
      (item) => item !== method && item !== "ONLINE"
    );
    setSecondPaymentModeData(filteredPaymentModes);
    setReceiveAmountError("Please Enter Receive Amount");
    if (method === "USER_ACCOUNT") {
      setReceiveAmountError("");
      if (!enableUserAccountDeliveryDiscount) {
        if (userAccountBalanceAmount < balanceAmount) {
          setUserAccountBalanceAmountError("Your Account Balance is Low");
        } else {
          setReceiveAmountValue(balanceAmount.toString());
        }
      } else {
        setUserAccountBalanceAmountError("");
      }
    } else if (receiveAmountValue === "" || receiveAmountValue === 0) {
      setReceiveAmountError("Please Enter Receive Amount");
      setUserAccountBalanceAmountError("");
    }
  };


  const handlePaymentMethodSecondChange = (method) => {
    setPaymentMethodSecondValue(method);
    setPaymentSecondError("");    
    setReceiveAmountSecondValue("");
    setUserAccountLowBalanceError("");
    setUserAccountBalanceAmountDeliveryError("");
    if (method === "USER_ACCOUNT") {
      setReceiveAmountSecondError("");
      if (!enableUserAccountDeliveryDiscount) {
        if (userAccountBalanceAmount < balanceAmount) {
          setUserAccountBalanceAmountError("Your Account Balance is Low");
        } else {
          setReceiveAmountSecondValue(balanceAmount.toString());
        }
      }
      else {
        setUserAccountBalanceAmountError("");
      }
    } else if (receiveAmountSecondValue === "" || 0) {
      setReceiveAmountSecondError("Please Enter Receive Amount");
      setUserAccountBalanceAmountError("");
    }
  };

  const paymentMethodDropdownRef = useRef();
  const discountDropdownRef = useRef();

  const paymentMethodDropdownSecondRef = useRef();

  const handlePaymentMethodRemove = () => {
    setPaymentMethodValue("");
    setUserAccountBalanceAmountDeliveryError("");
    if (receiveAmountValue > 0) {
      setReceiveAmountError("");
      setUserAccountBalanceAmountError("");
      setPaymentError("Please select any Payment Method");
    }
    setReceiveAmountError("");
    // Reset the selected item in the payment method dropdown
    if (paymentMethodDropdownRef.current) {
      paymentMethodDropdownRef.current.reset();
    }
    setReceiveAmountSecondValue("");
    setPaymentMethodSecondValue("")
    setAddMorePaymentMethod(false)
    setAddDiscount("");
    setAddDiscountValue("");
    setDiscountAmount("")
    updateBalanceAmount(receiveAmountValue, 0, 0);
  };

  const handlePaymentMethodSecondRemove = () => {
    setPaymentMethodSecondValue("");
    setUserAccountBalanceAmountDeliveryError("");
    if (receiveAmountSecondValue > 0) {
      setReceiveAmountSecondError("");
      setUserAccountBalanceAmountError("");
      setPaymentSecondError("Please select any Payment Method");
    }
    setReceiveAmountSecondError("");
    // Reset the selected item in the payment method dropdown
    if (paymentMethodDropdownSecondRef.current) {
      paymentMethodDropdownSecondRef.current.reset();
    }
  };

  const handleDiscountRemove = () => {
    setAddDiscountValue("");
    setDiscountAmount(0);
    updateBalanceAmount(receiveAmountValue, receiveAmountSecondValue, 0);
    if (discountDropdownRef.current) {
      discountDropdownRef.current.reset();
    }
  };

  const [focusedField, setFocusedField] = useState("");

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField("");
  };

  const fetchLoyaltyPointCheckDiscount = data => {
    getCustomerLoyaltyPointCheckDiscount(storeId, storeCustomerId, data)
      .then(response => {
        if (!response.data.error) {
          const Res = response.data;
          navigate("/LoyaltyPointRedeemNow", {
            state: {
              storeId: storeId,
              storeCustomerId: storeCustomerId,
              bookingOrderId: bookingOrderId,
              LoyaltyPoint: storeCustomerData?.loyaltyPoint,
              customerLoyaltyPointCheckDiscount: Res,
              balanceAmount: balanceAmount,
              invoiceNo: invoiceNo,
            },
          });
        }
      })
  }


   const [customerOrdersData, setCustomerOrdersData] = useState("")
  
    const [qrRes, setQrRes] = useState("")
    const [qrResStatus, setQrResStatus] = useState(false)
  
    const fetchCustomerSingleOrder = () => {
      // getCustomerSingleOrder(storeCustomerId, storeId, bookingOrderId)
      getCustomerSingleOrderInfo(storeCustomerId, storeId, bookingOrderId)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            setCustomerOrdersData(Res.balanceAmount);
          }
        })
        .catch((err) => {
          console.error("getCustomerSingleOrder Error:", err);
        });
    }
  
    const [paymentDone, setPaymentDone] = useState(false);
  
  
    useEffect(() => {
      let intervalId;
      let timeoutId;
      let isCompleted = false; // ✅ prevents double execution
  
      if (qrResStatus && !paymentDone) {
        intervalId = setInterval(async () => {
          fetchCustomerSingleOrder(); // ✅ get fresh value
  
          if (customerOrdersData === 0.0 && !isCompleted) {
            isCompleted = true;
  
            clearInterval(intervalId);
            clearTimeout(timeoutId);
  
            setPaymentDone(true);
  
            await sendScreen("success");
            setShowQRModal(false)
            
            setQrDeviceModalPayment({
              message: "success",
              status: "success",
              modalFun: false,
            });
  
            handleDiscountRemove();
            setPaymentMethodSecondValue("");
            setPaymentSecondError("");
            setReceiveAmountSecondValue("");
            setAddMorePaymentMethod(false);
            setReceiveAmountSecondError("");
          }
        }, 5000);
  
        // ✅ 30 sec timeout
        timeoutId = setTimeout(async () => {
          if (!isCompleted) {
            isCompleted = true;
  
            clearInterval(intervalId);
  
            setPaymentDone(true);
  
            await sendScreen("fail");
            setShowQRModal(false)
  
  
            setQrDeviceModalPayment({
              message: "failed",
              status: "failed",
              modalFun: false,
            });
  
            setQrRes("Payment timeout");
          }
        }, 300000);
      }
  
      return () => {
        if (intervalId) clearInterval(intervalId);
        if (timeoutId) clearTimeout(timeoutId);
      };
    }, [qrResStatus, paymentDone, customerOrdersData]);
  
  
  const upiAccountLinkCreated =
    "upi://pay?pa=" +
    upiAccountId +
    "&pn=" +
    upiAccountName +
    "&tr=MNO" +
    orderNo +
    "&am=" +
    balanceAmountValue +
    "&cu=INR&mc=5411"

     function getBaseUrl() {
        return `http://127.0.0.1:8053`;
      }
    
      function getEndpoint(type) {
        return {
          qr: "/rgb565/qr",
          success: "/rgb565/success",
          fail: "/rgb565/fail",
        }[type];
      }
    
      function drawCenteredText(ctx, text, font, y) {
        ctx.font = font;
        ctx.fillStyle = "black";
        const x = (DISPLAY_W - ctx.measureText(text).width) / 2;
        ctx.fillText(text, x, y);
      }
    
      function toRGB565Blob(canvas) {
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        const data = ctx.getImageData(0, 0, DISPLAY_W, DISPLAY_H).data;
    
        const out = new Uint8Array(DISPLAY_W * DISPLAY_H * 2);
        let idx = 0;
    
        for (let i = 0; i < DISPLAY_H; i++) {
          for (let j = 0; j < DISPLAY_W; j++) {
            const src = ((DISPLAY_H - 1 - i) * DISPLAY_W + j) * 4;
    
            const r = (data[src] >> 3) & 0x1f;
            const g = (data[src + 1] >> 2) & 0x3f;
            const b = (data[src + 2] >> 3) & 0x1f;
    
            const px = (r << 11) | (g << 5) | b;
    
            out[idx++] = (px >> 8) & 0xff;
            out[idx++] = px & 0xff;
          }
        }
    
        return new Blob([out], { type: "application/octet-stream" });
      }
    
      async function fetchImage(url) {
        const resp = await fetch(url);
        if (!resp.ok) throw new Error("Image load failed");
    
        const blob = await resp.blob();
        const objectUrl = URL.createObjectURL(blob);
    
        return new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => {
            URL.revokeObjectURL(objectUrl);
            resolve(img);
          };
          img.onerror = reject;
          img.src = objectUrl;
        });
      }
    
      async function drawBackground(url) {
        const canvas = document.getElementById("canvas");
        canvas.width = DISPLAY_W;
        canvas.height = DISPLAY_H;
    
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
        ctx.clearRect(0, 0, DISPLAY_W, DISPLAY_H);
    
        const img = await fetchImage(url);
        ctx.drawImage(img, 0, 0, DISPLAY_W, DISPLAY_H);
    
        return ctx;
      }
    
      // ---------------- CORE RENDER ----------------
    
      async function renderScreen(type) {
        const canvas = document.getElementById("canvas");
        const ctx = canvas.getContext("2d", { willReadFrequently: true });
    
        if (type === "qr") {
          await drawBackground(
            "https://download.rechargegrid.in/download/general/image/jpeg/_background.jpg"
          );
    
          const overlayCanvas = document.getElementById("overlayCanvas");
    
          await QRCode.toCanvas(overlayCanvas, upiAccountLinkCreated, {
            width: 260,
            margin: 1,
          });
    
          ctx.drawImage(overlayCanvas, 30, 150, 260, 260);
    
          drawCenteredText(ctx, storeLocalData?.currencySymbol + " " + balanceAmountValue, "bold 30px Arial", 130);
          drawCenteredText(ctx, "UPI ID: " + upiAccountId, "20px Arial", 440);
        }
    
        if (type === "fail") {
          await drawBackground("https://download.rechargegrid.in/download/general/image/jpeg/_fail.jpg");
          return;
        }
    
        if (type === "success") {
          await drawBackground(
            "https://download.rechargegrid.in/download/general/image/jpeg/_success.jpg"
          );
    
          drawCenteredText(
            ctx,
            storeLocalData?.currencySymbol + " " + (balanceAmountValue || "0.00"),
            "32px Arial",
            260
          );
        }
      }
    
      // ---------------- SEND TO DEVICE ----------------
    
      async function sendScreen(type) {
        try {
          await renderScreen(type);
    
          const endpoint = getEndpoint(type);
          if (!endpoint) throw new Error("Invalid type");
    
          const canvas = document.getElementById("canvas");
    
          const fd = new FormData();
          fd.append("file", toRGB565Blob(canvas), "image.bin");
    
          const resp = await fetch(getBaseUrl() + endpoint, {
            method: "POST",
            body: fd,
          });
    
          const text = await resp.text();
    
          if (resp.status === 200 && type === "qr") {
            setQrResStatus(true);
          }
    
          setQrRes("Response: " + text);
        } catch (err) {
          setQrRes("Error: " + err.message);
        }
      }
    
      // ---------------- BUTTON ----------------
    
      const handleSendQr = () => {
        setPaymentDone(false); // reset
        sendScreen("qr");
        // sendScreen("success");
      };

  return (
    <div>

      { balanceAmount > 0 && (<div
        className="flex justify-content-between align-items-center my-3 pl-4 pr-4"
        style={{
          borderRadius: "16px",
          // background: "linear-gradient(135deg, #eef2ff, #ffffff)",
          // boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
          flexWrap: "wrap",
        }}
      >
        {/* LEFT SECTION */}
        <div className="flex" style={{ gap: "12px" }}>

          {/* Wallet Balance */}
          {userAccountBalanceAmount > 0 && <div
            style={{
              background: "#ffffff",
              padding: "12px 16px",
              borderRadius: "10px",
              boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
            }}
          >
            <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
              Available Wallet Balance
            </p>
            <p
              style={{
                margin: 0,
                fontSize: "24px",
                fontWeight: "700",
                color: "#16a34a",
              }}
            >
              {storeLocalData?.currencySymbol} {Number(Number(userAccountBalanceAmount)?.toFixed(enabledAmountRoundOff))}
            </p>
          </div>}

          {/* Subscription */}
          {userAccountSubscriptionUnit > 0 && (
            <div
              style={{
                background: "#ffffff",
                padding: "12px 16px",
                borderRadius: "10px",
                boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
              }}
            >
              <p style={{ margin: 0, fontSize: "14px", color: "#666" }}>
                Available Subscription
              </p>
              <p
                style={{
                  margin: 0,
                  fontSize: "24px",
                  fontWeight: "700",
                  color: "#2563eb",
                }}
              >
                {storeLocalData?.currencySymbol} {Number(Number(userAccountSubscriptionUnit)?.toFixed(enabledAmountRoundOff))}
              </p>
            </div>
          )}
        </div>

        <div className="flex" style={{ gap: "12px" }}>
        {/* RIGHT SECTION (QR) */}
          {enabledUPIAccount && upiAccountId && balanceAmount > 0 && (subscriptionDiscount === 0 || subscriptionDiscount === null) && (
          <div
            className="flex flex-column align-items-center"
            style={{
              background: "#ffffff",
              padding: "8px",
              borderRadius: "14px",
              boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
              // minWidth: "140px",
            }}
          >
            <img
              src={
                STORE_BASE_URL +
                `/store/api/secure/v1/qr-code/qr-by-text/` +
                bookingOrderId +
                `/50/50`
              }
              alt="QR Code"
                onClick={() => {
                  setShowQRModal(true)
                  if (enabledQRDeviceModal) {
                    handleSendQr()
                  }
                }}
              style={{
                // width: "60px",
                // height: "60px",
                borderRadius: "8px",
                cursor: "pointer",
                transition: "0.3s",
              }}
            />
            <p style={{ fontSize: "12px", marginTop: "6px" }}>
              Tap to enlarge
            </p>
          </div>
        )}

          <div style={{ display: "none" }} class="right">
            <h3 >Preview</h3>
            <canvas id="canvas" width="320" height="480"></canvas>
            <canvas id="overlayCanvas" width="260" height="260" ></canvas>
            <div id="status">Ready</div>
          </div>

        <div
          className="flex flex-column align-items-center"
          style={{
            background: "#ffffff",
            padding: "8px",
            borderRadius: "14px",
            boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
            // minWidth: "140px",
            justifyContent:"center"
            
          }}
        >
          <div
            className="cursor-pointer"
            onClick={() => {
              setAddBalanceToWalletAccountModalVisible(true);
            }}
             
          >
            <i
              className="pi pi-credit-card"
              style={{
                fontSize: "35px",
                cursor: "pointer",
                color: "green",
                display:"flex",
                justifyContent:"center"
              }}
            ></i>
              <p style={{ fontSize: "12px", marginTop: "6px" }}>
                Add Wallet Balance
              </p>
          </div>
        </div>
        </div>
      </div>)}

      {showQRModal && (
        <div
          onClick={() => setShowQRModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          {/* STOP CLOSE WHEN CLICKING INSIDE */}
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: "relative",
              background: "#fff",
              padding: "20px",
              borderRadius: "16px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.2)",
              textAlign: "center",
            }}
          >
            {/* CLOSE BUTTON */}
            <div
              onClick={() => setShowQRModal(false)}
              style={{
                position: "absolute",
                top: "7px",
                right: "7px",
                fontSize: "20px",
                fontWeight: "bold",
                cursor: "pointer",
                color: "#444",
              }}
            >
              ✕
            </div>

            {/* BIG QR */}
            <img
              src={
                STORE_BASE_URL +
                `/store/api/secure/v1/qr-code/qr-by-text/` +
                bookingOrderId +
                `/250/250`
              }
              alt="QR Large"
              style={{
                width: "220px",
                height: "220px",
                borderRadius: "10px",
              }}
            />

            <p style={{ marginTop: "12px", fontWeight: "600" }}>
              Scan to Pay
            </p>
            <Button
                  className="mt-1 mb-3 mx-4 border-round-xl "
                  onClick={() => {
                    onRefreshQrPayment()
                    fetchCustomerSingleOrder(); // ✅ get fresh value
                    handleDiscountRemove();
                    setPaymentMethodSecondValue("");
                    setPaymentSecondError("");
                    setReceiveAmountSecondValue("");
                    setAddMorePaymentMethod(false);
                    setReceiveAmountSecondError("");
                    setShowQRModal(false)
                  }}
                  >
                <p className=" w-full text-2xl font-semibold flex justify-content-center">
                  Check Status
                </p>
                </Button>
          </div>
        </div>
      )}

      {!qrResStatus && 
        <>
      {balanceAmount > 0 && enabledLoyaltyPointBrand && enabledLoyaltyPointStore && storeCustomerData.loyaltyPoint > 0 &&
        <div className="flex justify-content-center align-items-center" style={{ paddingBottom: 10 }}>
          <button className="golden-button flex-1" onClick={() => {
            const loyaltyPointCheckDiscountData = {
              verificationRequested: true,
              amount: balanceAmount
            };
            fetchLoyaltyPointCheckDiscount(loyaltyPointCheckDiscountData)

          }}>
            <span className="shine" />
            {storeCustomerData.loyaltyPoint} Loyalty Points <i
              className="pi pi-send"
              style={{
                fontSize: "20px",
                cursor: "pointer",
                color: "#fff",
              }}
            ></i>
          </button>
        </div>}

      {balanceAmount > 0 &&
        enabledSubscriptionDiscountOnDelivery &&
        receiveAmountValue === "" &&
        paymentMethodValue === "" &&
        paidAmount === 0 &&
        (subscriptionDiscount === 0 || subscriptionDiscount === null) && (
          <PackageSubscriptionOfferDefault
            storeCustomerId={storeCustomerId}
            storeId={storeId}
            storeUserId={storeUserId}
            grandTotal={Math.round(balanceAmount)}
            onChecked={handleCheckPackageSubscriptionOffer}
            enabledApplySubscriptionWithPackage={enabledApplySubscriptionWithPackage}
            enabledAutoApplySubscriptionWithPackage={enabledAutoApplySubscriptionWithPackage}
            cartPackageData={orderPackageData}
          />
        )}
      {balanceAmount > 0 && (
        <div>
          <div
            className="flex flex-1 mx-4 my-2"
            style={{
              pointerEvents:
                paymentMethodValue === "USER_ACCOUNT" &&
                  subscriptionDiscount > 0
                  ? "none"
                  : "auto",
            }}
          >
            <div
              style={{
                display: "flex",
                flex: 0.5,
                marginRight: 10,
              }}
            >
              <div
                className="mx-2 flex w-1 justify-content-center align-items-center cursor-pointer"
                onClick={() => handlePaymentMethodRemove()}
                style={{ background: "red", borderRadius: 5, position: "relative", height: 44, top: 21 }}
              >
                <div>
                  <p className="text-xl font-bold text-white">X</p>
                </div>
              </div>
              <div className="flex-1">
                <p>Payment Method</p>
                <Dropdown
                  value={paymentMethodValue}
                  onChange={(e) => handlePaymentMethodChange(e.value)}
                  options={paymentModeData}
                  optionLabel="name"
                  placeholder="Payment Method"
                  disabled={
                    paymentMethodValue === "USER_ACCOUNT" &&
                    subscriptionDiscount > 0
                  }
                  className="w-full  bg-white-alpha-20  text-2xl text-primary-50 shadow-2"
                />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flex: 0.5,
                marginRight: 10,
              }}
            >
              <div className="flex-1">
                <p>Receive Amount</p>
                <InputText
                  value={receiveAmountValue}
                  onChange={(e) => handleReceiveAmountChange(e.target.value)}
                  className="w-full text-xl  border-round-xl shadow-2"
                  style={{
                    backgroundColor: "#fff",
                  }}
                  keyboardType="numeric"
                  editable={
                    paymentMethodValue === "USER_ACCOUNT"
                      ? enableUserAccountDeliveryDiscount
                        ? true
                        : false
                      : true
                  }
                />
              </div>
              {!(
                (paymentMethodValue === "USER_ACCOUNT" && subscriptionDiscount > 0) ||
                paymentMethodValue === "ONLINE" ||
                parseFloat(balanceAmountValue) === 0
              ) &&
                !userAccountLowBalanceError && 
                paymentMethodValue &&
                receiveAmountValue &&
                !addMorePaymentMethod && (
                  <div
                    className="mx-2 flex w-1 justify-content-center align-items-center cursor-pointer"
                    onClick={handleAddMorePaymentMethod}
                    style={{ background: "#2B70D7", borderRadius: 5, position: "relative", height: 44, top: 21 }}
                  >
                    <p className="text-xl font-bold text-white">+</p>
                  </div>
                )}
            </div>
          </div>

          {paymentMethodValue && receiveAmountValue && addMorePaymentMethod &&
            <div className="flex flex-1 mx-4 my-2">
              <div
                style={{
                  display: "flex",
                  flex: 0.5,
                  marginRight: 10,
                }}
              >
                <div
                  className="mx-2 flex w-1 justify-content-center align-items-center cursor-pointer"
                  onClick={() => handlePaymentMethodSecondRemove()}
                  style={{ background: "red", borderRadius: 5, position: "relative", height: 44, top: 21 }}
                >
                  <div>
                    <p className="text-xl font-bold text-white">X</p>
                  </div>
                </div>
                <div className="flex-1">
                  <p>Payment Method</p>
                  <Dropdown
                    value={paymentMethodSecondValue}
                    onChange={(e) => handlePaymentMethodSecondChange(e.value)}
                    options={secondPaymentModeData}
                    optionLabel="name"
                    placeholder="Payment Method"
                    disabled={
                      paymentMethodSecondValue === "USER_ACCOUNT" &&
                      subscriptionDiscount > 0
                    }
                    className="w-full  bg-white-alpha-20  text-2xl text-primary-50 shadow-2"
                  />
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  flex: 0.5,
                  marginRight: 10,
                }}
              >
                <div className="flex-1">
                  <p>Receive Amount</p>
                  <InputText
                    value={receiveAmountSecondValue}
                    onChange={(e) => handleReceiveAmountSecondChange(e.target.value)}
                    className="w-full text-xl  border-round-xl shadow-2"
                    style={{
                      backgroundColor: "#fff",
                    }}
                    keyboardType="numeric"
                    editable={
                      paymentMethodSecondValue === "USER_ACCOUNT"
                        ? enableUserAccountDeliveryDiscount
                          ? true
                          : false
                        : true
                    }
                  />
                </div>
              </div>
            </div>}
        </div>
      )}
      {paymentError !== "" && (
        <div className="flex flex-1 mx-4 my-2">
          <p className="text-lg font-normal mt-2" style={{ color: "red" }}>
            {paymentError}
          </p>
        </div>
      )}
      {paymentSecondError !== "" && (
        <div className="flex flex-1 mx-4 my-2">
          <p className="text-lg font-normal mt-2" style={{ color: "red" }}>
            {paymentSecondError}
          </p>
        </div>
      )}

      {balanceAmount > 0 && (
        <div
          className="mx-4 my-2 flex flex-1"
          style={{
            pointerEvents:
              paymentMethodValue === "USER_ACCOUNT" && subscriptionDiscount > 0
                ? "none"
                : "auto",
          }}
        >
          <div className="flex-1 mb-2">
            <p>Balance Amount</p>
            <InputText
              value={balanceAmountValue}
              onChange={(e) => handleBalanceAmountChange(e.target.value)}
              className="w-full text-xl  border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
              keyboardType="numeric"
              editable={false}
            />
          </div>
        </div>
      )}
      {balanceAmount > 0 && (
        <div className="mx-4">
          <div>
            {receiveAmountError !== "" && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {receiveAmountError}
              </p>
            )}
          </div>
          <div>
            {receiveAmountSecondError !== "" && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {receiveAmountSecondError}
              </p>
            )}
          </div>
          <div>
            {userAccountBalanceAmountError !== "" && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {userAccountBalanceAmountError}
              </p>
            )}
          </div>
            <div>
              {userAccountLowBalanceError !== "" && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {userAccountLowBalanceError}
                </p>
              )}
            </div>
        </div>
      )}
      {/** balanceAmountValue > 0 && */}
      {balanceAmount > 0 && balanceAmountValue > 0 && (
        <div>
          {(subscriptionDiscount === null || subscriptionDiscount === 0) && (
            <div>
              {paymentMethodValue !== "ONLINE" &&
                deliveryDiscount &&
                balanceAmountCal !== receiveAmountValue && (
                  <div className="flex-1 mx-4 my-2">
                    <div className="flex flex-1 ">
                      <Dropdown
                        value={addDiscountValue.toString()}
                        onChange={(e) => handleAddDiscountChange(e.value)}
                        options={dropdownItemsDiscount}
                        optionLabel="name"
                        placeholder="Discount"
                        className="w-full  bg-white-alpha-20  text-2xl text-primary-50 shadow-2"
                      />

                      <div
                        className="mx-2 flex w-1 justify-content-center align-items-center cursor-pointer"
                        onClick={() => handleDiscountRemove()}
                        style={{ background: "red", borderRadius: 5 }}
                      >
                        <div>
                          <p className="text-xl font-bold text-white">X</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              {deliveryDiscount && discountAmount > 0 && (
                <div className="mx-4 my-2">
                  <div>
                    <p>Discount Amount</p>
                    <InputText
                      value={discountAmount.toString()}
                      // onChange={handleOtherRemarkChange}
                      className="w-full text-xl  border-round-xl shadow-2"
                      style={{
                        backgroundColor: "#fff",
                      }}
                      onFocus={() => handleFocus("otherRemark")}
                      onBlur={handleBlur}
                      editable={false}
                    />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <div className="mx-4 my-2">
        <div>
          <p>Other Remark</p>
          <InputText
            className="w-full text-xl h-3rem border-round-xl shadow-2"
            style={{
              backgroundColor: "#fff",
            }}
            value={otherRemarkValue}
            onChange={(e) => handleOtherRemarkChange(e.target.value)}
            onFocus={() => handleFocus("otherRemark")}
            onBlur={handleBlur}
          />
        </div>
      </div>
      {balanceAmount < 0 && (
        <div>
          <div className="mx-4 my-2">
            <div className="w-full flex px-4 h-3rem  text-2xl border-round-xl shadow-2 justify-content-start align-items-center">
              <p className="text-xl font-normal" style={{ color: "#666" }}>
                Return Balance Amount
              </p>
              <p className="text-xl font-normal ml-2" style={{ color: "#000" }}>
                  {" ( " + storeLocalData?.currencySymbol + " " + -balanceAmount + ") "}
              </p>
            </div>
          </div>
          <div className="mx-4 my-2">
            <div className="flex justify-content-between align-items-center">
              {
                <div
                  style={{
                    pointerEvents: isCheckedRefundAmountUserAccount
                      ? "auto"
                      : "none",
                  }}
                  className="w-full flex px-4 h-3rem  text-2xl border-round-xl shadow-2 justify-content-between align-items-center"
                >
                  <p className="text-xl font-normal" style={{ color: "#000" }}>
                    Cash
                  </p>
                  <div className="flex justify-content-start align-items-center">
                    <Checkbox
                      size={15}
                      checked={isCheckedRefundAmountCash}
                      color={isCheckedRefundAmountCash ? "#00A3FF" : "#C1C9D3"}
                      // disabled={true}
                      onClick={() => {
                        setIsCheckedRefundAmountCash(
                          !isCheckedRefundAmountCash
                        );
                        if (!isCheckedRefundAmountCash) {
                          setIsCheckedRefundAmountUserAccount(false);
                          setPaymentMethodRefundValue("CASH");
                        } else {
                          setIsCheckedRefundAmountUserAccount(true);
                          setPaymentMethodRefundValue("USER_ACCOUNT");
                        }
                      }}
                    />
                  </div>
                </div>
              }

              <div className="w-full flex px-4 h-3rem  text-2xl border-round-xl shadow-2 justify-content-between align-items-center">
                <p className="text-xl font-normal" style={{ color: "#000" }}>
                  User Account
                </p>
                <div className="flex justify-content-start align-items-center">
                  <Checkbox
                    size={15}
                    checked={isCheckedRefundAmountUserAccount}
                    color={
                      isCheckedRefundAmountUserAccount ? "#00A3FF" : "#C1C9D3"
                    }
                    onClick={() => {
                      setIsCheckedRefundAmountUserAccount(
                        !isCheckedRefundAmountUserAccount
                      );
                      if (!isCheckedRefundAmountUserAccount) {
                        setIsCheckedRefundAmountCash(false);
                        setPaymentMethodRefundValue("USER_ACCOUNT");
                      } else {
                        setIsCheckedRefundAmountCash(true);
                        setPaymentMethodRefundValue("CASH");
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      </>
    }
      <AddBalanceToWalletAccountModal
        addBalanceToWalletAccountModalVisible={
          addBalanceToWalletAccountModalVisible
        }
        setAddBalanceToWalletAccountModalVisible={
          setAddBalanceToWalletAccountModalVisible
        }
        storeCustomerId={storeCustomerId}
        storeId={storeId}
        storeUserId={storeUserId}
        sendPaymentDetailsPage={receivePaymentDetailsInfo}
      />
    </div>
  );
};

export default PaymentDetails;
